export default __webpack_public_path__ + "static/media/audit.134c9654.svg";